<footer *ngIf="isStudentExperience" class="container-wrapper selenium-app-footer">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                <div class="teacher-view-button" *ngIf="!isStudentLoggedIn">
                    <a class="{{ gtmPrefix + 'teacher-button ' + 'btn' }}" href="/" role="button"
                        >Teacher? Click Here</a
                    >
                </div>
                <div class="logos">
                    <a
                        class="{{ gtmPrefix + 'logo-pbs ' + 'logo-pbs' }}"
                        [attr.data-gtmlabel]="'PBS'"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img [src]="pbsLogoWhite" alt="PBS LearningMedia" />
                    </a>
                    <a
                        class="{{ gtmPrefix + 'logo-wgbh ' + 'logo-wgbh' }}"
                        [attr.data-gtmlabel]="'WGBH'"
                    >
                        <img
                            src="https://d43fweuh3sg51.cloudfront.net/defaults/wgbh-logo.svg"
                            alt="WGBH logo"
                        />
                    </a>
                </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-7 col-xl-8 links">
                <div>
                    <app-link href="/help/privacy-policy/" target="_blank" rel="noopener noreferrer"
                        >Privacy Policy</app-link
                    >
                </div>
                <div>
                    <app-link href="/help/terms-of-use/" target="_blank" rel="noopener noreferrer"
                        >Terms of Use</app-link
                    >
                </div>
                <div>
                    <app-link
                        href="/help/"
                        class="{{ gtmPrefix + 'help' }}"
                        [attr.data-gtmlabel]="'Help'"
                        >Help</app-link
                    >
                </div>
            </div>
        </div>
        <div class="row legal-and-contact">
            <div class="col-xs-12 col-sm-12 col-md-7 col-lg-5">
                <div class="rights-reserved">
                    &copy; {{ currentYear }} PBS &amp; WGBH Educational Foundation. All rights
                    reserved.
                </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-5 col-lg-7"></div>
        </div>
    </div>
</footer>
